import type { GroupChannel } from '@sendbird/chat/groupChannel';
import { useAtomValue } from 'jotai';

import { adminUserAtom, allMembershipsAtom } from '../../entities/entityAtoms';

export const useMembershipOfSendbirdChannel = (
    channel: GroupChannel | null,
) => {
    const adminUser = useAtomValue(adminUserAtom);
    const allMemberships = useAtomValue(allMembershipsAtom);

    // Filter channel members to exclude current Guide.
    const members =
        channel?.members?.filter((member) => {
            return member.userId !== adminUser.guide?.sendbirdUserId;
        }) ?? [];
    const memberSendbirdUserId = members[0]?.userId;

    if (memberSendbirdUserId == null) {
        return null;
    }

    // Find the associated membership for the guide and the channel members.
    const membership = allMemberships.find((membership) => {
        return (
            membership.guideId === adminUser.guideId &&
            membership.users.some(
                (user) => user.sendbirdUserId === memberSendbirdUserId,
            )
        );
    });

    return membership;
};
